<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" *ngIf="isLoaded">
    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node
        matRipple
        class="tree-node"
        [class.node-highlight]="isSelectedNode === node"
        *matTreeNodeDef="let node"
        matTreeNodePadding
        matTreeNodePaddingIndent="20px"
        (click)="navigateTo(node)">
        <!-- use a disabled button to provide padding for tree leaf -->

        <span class="node-without-button" fxLayoutAlign="center center">
            <mat-icon color="primary" class="prefix-icon">assignment</mat-icon>{{ node.title }}
        </span>
    </mat-tree-node>
    <!-- This is the tree node template for expandable nodes -->
    <mat-tree-node
        matRipple
        class="tree-node"
        *matTreeNodeDef="let node; when: hasChild"
        matTreeNodePadding
        matTreeNodeToggle
        matTreeNodePaddingIndent="20px">
        <mat-icon>
            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
        {{ node.title }}
    </mat-tree-node>
</mat-tree>
